"use client";

import { trackComponent } from "@repo/analytics";
import { dlEventConstants } from "@repo/analytics/data-layer.constants";
import { getCustomerIdForAnalytics } from "../../utils/analytics-utils";
import {
  BUDGET_ETF_CAMPAIGN,
  BUDGET_ETF_COMPONENT_NAME,
  BUDGET_ETF_JOURNEY_TAG,
  BUDGET_ETF_PRODUCT_CATEGORY,
  BUDGET_ETF_PRODUCT_NAME,
  BUDGET_ETF_PROPERTY_TYPE,
  BUDGET_ETF_REFERENCE_ID,
  BUDGET_ETF_SPRINT,
} from "./budgetEtfTrackingConstants";

interface TrackBudgetEtfClickParams {
  clickType: string;
  sectionTitle: string;
  ctaText: string;
  componentPosition?: string;
  tabPosition?: string;
}

export const trackBudgetEtfClick = async ({
  clickType,
  sectionTitle,
  ctaText,
  componentPosition,
  tabPosition,
}: TrackBudgetEtfClickParams): Promise<void> => {
  try {
    const customerId = await getCustomerIdForAnalytics();

    await trackComponent({
      componentName: BUDGET_ETF_COMPONENT_NAME,
      sectionTitle,
      eventType: dlEventConstants.CLICK,
      clickType,
      ctaText,
      productCategory: BUDGET_ETF_PRODUCT_CATEGORY,
      ...(tabPosition ? { tabPosition } : {}),
      cleverTapOverrides: {
        EP_JOURNEY: BUDGET_ETF_JOURNEY_TAG,
        EP_PROPERTY_TYPE: BUDGET_ETF_PROPERTY_TYPE,
        EP_PRODUCT_NAME: BUDGET_ETF_PRODUCT_NAME,
        EP_CAMPAIGN: BUDGET_ETF_CAMPAIGN,
        EP_SPRINT: BUDGET_ETF_SPRINT,
        EP_REFERENCE_ID: BUDGET_ETF_REFERENCE_ID,
        ...(customerId && { EP_CUSTOMER_ID: customerId }),
        ...(componentPosition && { EP_SR_NUMBER: componentPosition }),
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to track budget friendly ETF click", error);
  }
}; 
